import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface IDeleteIssueRequest extends IBaseRequest {
  ident?: string;
  multiChange?: string;
  multiEventTask?: false;
  headId?: string;
}

export class DeleteIssueRequest extends BaseRequest implements IDeleteIssueRequest {
  public ident?: string;
  public multiChange?: string;
  public multiEventTask?: false;
  public headId?: string;

  constructor(server: string, session: string, ident: string, multiEventTask?: false, headId?: string, multiChange?: string) {
    super(server, session);
    this.ident = ident;
    this.multiChange = multiChange;
    this.multiEventTask = multiEventTask;
    this.headId = headId;
  }

  public toXml(): string {
    let parameters: string = super.toXml();

    parameters += this.makeNode(this.ident, 'ident');
    parameters += this.makeNode(this.multiChange, 'multiChange');
    parameters += this.makeNode(this.multiEventTask, 'multiEventTask');
    parameters += this.makeNode(this.headId, 'headId');

    return super.wrapperXml('DeleteIssue', parameters);
  }
}
